import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { IbkDialogConfig } from 'src/app/shared/class/modal/ibk-dialogConfig.class';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  isOpen: BehaviorSubject<IbkDialogConfig> = new BehaviorSubject<IbkDialogConfig>(
    {
      data: {
        icon: '',
        title: '',
        description: ''
      },
      isOpen: false
    }
  );

  accionCloseUpdated: Subject<string> = new Subject<string>();

  openModal(options: IbkDialogConfig): Observable<string> {
    this.isOpen.next(options);
    return this.accionCloseUpdated.asObservable();
  }

}
